var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1C4.89543 1 4 1.89543 4 3V5C4 6.10457 4.89543 7 6 7H18C19.1046 7 20 6.10457 20 5V3C20 1.89543 19.1046 1 18 1H6ZM6 8C4.89543 8 4 8.89543 4 10V15C4 16.1046 4.89543 17 6 17H18C19.1046 17 20 16.1046 20 15V10C20 8.89543 19.1046 8 18 8H6ZM4 20C4 18.8954 4.89543 18 6 18H18C19.1046 18 20 18.8954 20 20V21C20 22.1046 19.1046 23 18 23H6C4.89543 23 4 22.1046 4 21V20ZM9.75 3C9.33579 3 9 3.33579 9 3.75C9 4.16421 9.33579 4.5 9.75 4.5H14.25C14.6642 4.5 15 4.16421 15 3.75C15 3.33579 14.6642 3 14.25 3H9.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryBig);
export default __webpack_public_path__ + "static/media/inventoryBig.dd57ef297fa637b53b20f13a348fecae.svg";
export { ForwardRef as ReactComponent };